export const XCusIcon = ({ width = 14, height = 14, className = '', ...props }) => {
    return (
        <svg width={width} height={height} className={className} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M13.5 0.5L0.5 13.5' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M0.5 0.5L13.5 13.5' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
        </svg>

    );
};
